import type { BlockArgumentsRecord } from "./block-arguments-record";
import { ChecklistArgumentsRecord } from "./checklist-arguments-record";

const validateChecklistRequest = (request: Record<string, unknown>): void => {
    const items = request.items;
    if (!Array.isArray(items)) {
        throw new Error("request.items must be an array.");
    }

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (
            !item ||
            typeof item !== "object" ||
            typeof (item as Record<string, unknown>).text !== "string"
        ) {
            throw new Error(`request.items[${i}].text must be a string.`);
        }
    }
};

export const BlockArgumentsRecordFactory = (
    rawArguments: string
): BlockArgumentsRecord => {
    let parsed: unknown;

    try {
        parsed = JSON.parse(rawArguments);
    } catch {
        throw new Error("Tool call arguments must be valid JSON.");
    }

    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        throw new Error("Tool call arguments must be an object.");
    }

    const parsedObject = parsed as Record<string, unknown>;
    const request = parsedObject.request;

    if (!request || typeof request !== "object" || Array.isArray(request)) {
        throw new Error("request must be an object.");
    }

    const requestObject = request as Record<string, unknown>;
    const type = requestObject.type;

    if (typeof type !== "string") {
        throw new Error("request.type must be a string.");
    }

    switch (type) {
        case "checklist": {
            validateChecklistRequest(requestObject);

            return new ChecklistArgumentsRecord({
                request: requestObject as any,
            });
        }
        default:
            throw new Error(`Unsupported block argument type: ${type}.`);
    }
};
